import type { ChatMessage } from "./types";

// sessionStorage keyed by site. Survives nav within a tab, clears on close.
// Wrapped in try/catch — sessionStorage throws in private mode on some browsers.

const keyFor = (site: string) => `scalebloom-chatbot:${site}`;

export function loadMessages(site: string): ChatMessage[] {
  try {
    const raw = sessionStorage.getItem(keyFor(site));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (m): m is ChatMessage =>
        m && typeof m === "object" &&
        (m.role === "user" || m.role === "assistant") &&
        typeof m.content === "string",
    );
  } catch {
    return [];
  }
}

export function saveMessages(site: string, messages: ChatMessage[]): void {
  try {
    sessionStorage.setItem(keyFor(site), JSON.stringify(messages));
  } catch {
    /* swallow quota/private-mode errors */
  }
}
